// extracted by mini-css-extract-plugin
export default {"sider":"SiderContent_sider__JWwdo","menu":"SiderContent_menu__Y6rVy"};